import { Routes, Route, Navigate } from 'react-router-dom';
import Authorized from './Auth/Authortized';
import EventSetup from './EventSetup/EventSetup';
import LandingPage from './LandingPage';
import MatchDataImport from './MatchDataImport/MatchDataImport';
import MatchStrategy from './MatchStrategy/MatchStrategy';
import Picklist from './Picklist/Picklist';
import TeamParser from './TeamParser/TeamParser';


export default function routing() {
    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />

            <Route path="/matchstrategy" element={<MatchStrategy />} />
            <Route path="/picklist" element={<Picklist />} />
            <Route path="/teamparser" element={<TeamParser />} />
            <Route path="/eventsetup" element={<EventSetup />} />
            <Route path="/matchdataimport" element={<MatchDataImport />} />


            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>  
     )
}